// extracted by mini-css-extract-plugin
export var videoAreaContainer = "bT_g9";